/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

export const HEAD_CLINIC_DATA = "HEAD_CLINIC_DATA";
export const CONSTANT_DATA = "CONSTANT_DATA";